<!--
 * @Description: 新增活码页面
 * @Author: mdb
 * @Date: 2023-04-17 16:07:46
 * @LastEditTime: 2023-04-19 16:34:26
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm type="add" :title="t('marketing.新增市场活动')" paramCode="ofbu_source_channel" subdomain="ofbu" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import DetailForm from './components/DetailForm.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>
<script lang="ts">
export default { name: 'DcCosOFbuActivityCodeAdd' }
</script>

<style scoped></style>
